<template>
  <div>
    <vue-headful :title="getPageTitle" description="Description goes here" />
    <div class="class-feeds-section mt-5 base-type-layout">
      <div class="container px-1">
        <transition name="fade" mode="out-in" v-if="false">
          <back-to-school-upgrade-alert
            v-if="getBackToSchoolStatus && false"
            @closeUpgradeAlert="closeBackToSchoolAlertCard"
          />
        </transition>

        <div class="row">
          <!-- CHILD INFO COLUMN -->
          <div class="col-12 col-md-3 col-lg-3 left-layout">
            <!-- PARENT CHILD COMPONENT -->
            <div v-if="account_type === 'parent'">
              <ParentChildCard @switchChild="getChildIDState"></ParentChildCard>
            </div>
            <!-- PARENT CHILD COMPONENT -->

            <!-- STUDENT PROFILE CARD COMPONENT -->
            <div v-if="account_type === 'student'">
              <StudentProfileCard
                :child_img="getAuthUser.image"
                :child_name="getAuthUser.full_name"
                :class_code="getAuthUser.code"
                card_type="student"
                @showExamConfig="toggleExamModal"
              ></StudentProfileCard>
            </div>
            <!-- STUDENT PROFILE CARD COMPONENT -->
          </div>
          <!-- CHILD INFO COLUMN -->

          <!-- CLASS FEEDS -->
          <div class="col-12 col-md-9 col-lg-9 right-layout">
            <!-- UPGRADE ALERT CARD -->
            <template>
              <UpgradeAlertCard
                v-if="show_subscription_alert_card && false"
                @closeUpgradeAlert="toggleSubscriptionAlertCard"
                @backToSchoolStatus="toggleBackToSchoolAlertCard($event)"
              ></UpgradeAlertCard>
            </template>

            <!-- POST INPUT CARD -->
            <PostInputCardNew
              :fullname="getAuthUser.full_name"
              @subscription-status="status = $event"
              @catchup-status="catchup_status = $event"
            ></PostInputCardNew>

            <div class="row">
              <!-- EXAM MODE ENTRY -->
              <template v-if="false">
                <div class="col-12 transition" v-if="show_exam_mode">
                  <ExamModeEntry @configureExam="toggleExamModal" />
                </div>
              </template>

              <!-- POSTS SECTION -->
              <div class="col-12 col-md-7 order-2 order-lg-1 post-component">
                <!-- POST BLOCK COMPONENTS -->

                <template v-if="is_fetching">
                  <SkeletonPostBlock key="1" />
                  <SkeletonPostBlock key="2" />
                </template>

                <template v-else>
                  <GettingStartedList
                    :subscription_status="catchup_status"
                    :back_to_school_status="show_back_to_school_alert && false"
                    :post_content_length="posts.length"
                    :enrolled="getEnrolled"
                    @connectSchool="add_child_to_school = true"
                    @updateSchool="getChildIDState"
                  />
                  <div class="content-post-section" v-if="posts.length > 0">
                    <PostBlock :posts="posts" :subscription_status="status" />
                  </div>
                </template>
                <!-- POST BLOCK COMPONENTS -->

                <!-- INFINITE SCROLLER -->
                <template v-if="!infinite_scroll_end || is_fetching">
                  <SkeletonPostBlock
                    v-if="posts.length"
                    v-observe-visibility="{
                      callback: fetchMorePost,
                      throttle: 300,
                    }"
                  />
                </template>
                <!-- INFINITE SCROLLER -->
              </div>

              <!-- UPCOMING EVENTS -->
              <div class="col-12 col-md-5 order-1 order-lg-2 event-component">
                <UpcomingEventBlock
                  @connectSchool="add_child_to_school = true"
                  @updateSchool="getChildIDState"
                  :subscription_status="status"
                ></UpcomingEventBlock>
              </div>
            </div>
          </div>
          <!-- CLASS FEEDS -->
        </div>
      </div>
    </div>

    <!-- MODALS -->
    <WelcomeDialogue
      v-if="
        !getBoardedStatus && show_welcome_banner && account_type !== 'parent'
      "
      @updateBoarded="updateBoardedStatus"
      @closeDialog="updateBoardedStatus"
    ></WelcomeDialogue>

    <ConfigureExamModal
      v-if="show_exam_modal"
      @closeTriggered="toggleExamModal"
    />

    <portal to="app-modals">
      <summer-school-welcome-modal
        v-if="false"
        @closeTriggered="toggleSummerWelcomeModal"
      />

      <back-to-school-banner
        v-if="getBackToSchoolBannerStatus && false"
        @closeTriggered="show_back_to_school = false"
      />

      <add-child-class-modal
        :childDetail="getUnSchooledChild"
        :token="getSelectedChildToken"
        v-if="add_child_to_school"
        @closeTriggered="add_child_to_school = false"
        @updateSchool="getChildIDState"
      />
    </portal>
    <!-- MODALS -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { capitalizeFirstLetter } from "@/scripts/utilities";
import ParentChildCard from "@/components/classComps/parentSideBar/ParentChildCard";
import StudentProfileCard from "@/components/profileComps/studentprofile/StudentProfileCard";
import PostInputCardNew from "@/components/classComps/feeds/PostInputCardNew";
import SkeletonPostBlock from "@/components/classComps/feeds/SkeletonPostBlock";
import GettingStartedList from "@/components/classComps/feeds/GettingStartedList";
import PostBlock from "@/components/classComps/feeds/PostBlock";
import backToSchoolUpgradeAlert from "@/components/classComps/feeds/backToSchoolUpgradeAlert";
import BackToSchoolBanner from "@/components/modalComps/classModals/BackToSchoolBanner";
import AddChildClassModal from "@/components/modalComps/studentModals/AddChildClassModal";

export default {
  name: "Feeds",

  components: {
    ParentChildCard,
    StudentProfileCard,
    PostInputCardNew,
    GettingStartedList,
    PostBlock,
    SkeletonPostBlock,
    backToSchoolUpgradeAlert,
    BackToSchoolBanner,
    AddChildClassModal,
    WelcomeDialogue: () =>
      import("@/components/schoolComps/welcome/WelcomeDialog"),
    UpgradeAlertCard: () =>
      import("@/components/classComps/feeds/UpgradeAlertCard"),
    UpcomingEventBlock: () =>
      import("@/components/classComps/feeds/UpcomingEventBlock"),
    ExamModeEntry: () => import("@/components/classComps/feeds/ExamModeEntry"),
    ConfigureExamModal: () =>
      import("@/components/modalComps/classModals/ConfigureExamModal"),
    SummerSchoolWelcomeModal: () =>
      import("@/components/modalComps/classModals/SummerSchoolWelcomeModal"),
  },

  computed: {
    ...mapState(["feed_delete_id"]),
    ...mapGetters([
      "getAuthUser",
      "getSelectedChildID",
      "getCurrentClass",
      "getParentChildrenList",
      "getChildrenTokens",
      "isChildEnrolled",
    ]),

    getGradelyToken() {
      return localStorage.getItem("gradelyAuthToken");
    },

    getPageTitle() {
      return `Feeds | ${capitalizeFirstLetter(this.account_type)}`;
    },

    getSelectedChild() {
      return this.getParentChildrenList.find((child) => {
        return Number(child.id) === Number(this.getSelectedChildID);
      });
    },

    getSelectedChildToken() {
      return (
        this.getChildrenTokens.find((item) => {
          return Number(item.child_id) === Number(this.getSelectedChildID);
        })?.token || ""
      );
    },

    getUnSchooledChild() {
      if (!this.getSelectedChild?.child_class_details?.has_school)
        return this.getSelectedChild;
      return this.getParentChildrenList.find((child) => {
        return !child?.child_class_details?.has_school;
      });
    },

    getChildrenEnrollment() {
      return this.getSelectedChild?.child_class_details?.has_school
        ? true
        : false;
    },

    getChildEnrollment() {
      return this.getAuthUser?.class?.class_code || this.isChildEnrolled
        ? true
        : false;
    },

    getEnrolled() {
      return this.account_type === "parent"
        ? this.getChildrenEnrollment
        : this.getChildEnrollment;
    },

    getAuthStatus() {
      return localStorage.getItem("gradelyAuthToken");
    },

    getBoardedStatus() {
      return this.getAuthUser.is_boarded;
    },

    getRelationship() {
      return this.getAuthUser.relationship;
    },

    getBackToSchoolStatus() {
      let closed_back_to_school_alert =
        localStorage.getItem("backToShoolStatus");
      return this.show_back_to_school_alert && !closed_back_to_school_alert;
    },

    getBackToSchoolBannerStatus() {
      let banner_ready = localStorage.getItem("now_show_back_to_school_banner");
      return this.show_back_to_school && banner_ready;
    },
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      welcome_dialogue: false,
      in_view: "PostBlock",
      status: false,
      catchup_status: false,

      child_active_id: null,
      posts: [],
      post_count: 0,

      page: 1,
      page_end: 0,
      infinite_scroll_end: false,
      is_fetching: false,
      add_child_to_school: false,

      show_subscription_alert_card: true,
      show_back_to_school_alert: false,
      show_exam_mode: false,
      show_exam_modal: false,

      show_welcome_banner: true,
      show_summer_welcome: false,
      show_back_to_school: false,
      now_show_back_to_school_banner: false,
    };
  },

  watch: {
    $route: {
      handler(newVal) {
        if (newVal) this.getChildIDState();
      },
    },

    getRelationship: {
      handler(relationship) {
        let account_type = this.$route.path.split("/")[1];
        if (!relationship && account_type === "parent")
          this.$router.push("/parent/onboarding/new-child");
      },
      immediate: true,
    },

    getSelectedChild: {
      async handler(new_child, old_child) {
        console.log("selected child chnaging>>>", new_child, old_child);
        if (
          !this.getSelectedChildToken &&
          !!new_child &&
          new_child?.id !== old_child?.id
        )
          await this.getChildToken(new_child?.id);
      },
      immediate: true,
      deep: true,
    },
  },

  created() {
    let payment_package = localStorage.getItem("paymentRedirect");
    let redirect = this.$route.query.redirect;
    this.$bus.$on("event-bus-logout-user", () => {
      this.show_welcome_banner = false;
    });

    if (this.account_type === "parent" && payment_package && redirect) {
      delete localStorage.paymentRedirect;
      this.$router.push(
        `/parent/settings/upgrade-plan?type=${payment_package}`
      );
    }

    // this.checkSummerSchoolLog();
    this.checkBackToSchoolLog();

    this.$bus.$on("event-bus-remount-post-list", this.getChildIDState);
    this.$bus.$on("event-bus-extract-post", this.extractDeletedPostFromList);
  },

  mounted() {
    // this.updateBoardedStatus();
    this.getChildIDState();
    this.checkForEmailVerification();

    setTimeout(() => (this.show_exam_mode = true), 4000);
  },

  methods: {
    ...mapActions([
      "updateBoardingStatus",
      "getFeeds",
      "getParentChildren",
      "setCurrentClass",
      "getStudentClassDetailsById",
      "getNewFeatureLog",
      "getChildToken",
    ]),

    toggleExamModal() {
      this.show_exam_modal = !this.show_exam_modal;
    },

    toggleSummerWelcomeModal() {
      this.show_summer_welcome = !this.show_summer_welcome;
    },

    checkSummerSchoolLog() {
      if (this.$route.query.summer) {
        this.getNewFeatureLog("summer_config")
          .then((response) => {
            if (!response.data) this.toggleSummerWelcomeModal();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    checkBackToSchoolLog() {
      this.getNewFeatureLog("back2School_config")
        .then((response) => {
          if (!response.data)
            this.show_back_to_school = !this.show_back_to_school;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    checkForEmailVerification() {
      let localStorageName = localStorage.getItem("emailVerificationMessage");
      if (localStorageName !== null) {
        setTimeout(() => {
          if (localStorageName !== null) {
            let localStorageValue = JSON.parse(localStorageName);

            this.response_dialog = true;
            this.alert_card_type = localStorageValue.type;
            this.alert_card_msg = localStorageValue.message;
          }
        }, 2000);

        setTimeout(() => {
          delete localStorage.checkForEmailVerification;
          this.response_dialog = false;
        }, 6000);
      }
    },

    toggleSubscriptionAlertCard() {
      this.show_subscription_alert_card = !this.show_subscription_alert_card;
    },

    toggleBackToSchoolAlertCard(status) {
      console.log("back to sch status", status);
      setTimeout(() => {
        this.show_back_to_school_alert = status;
      }, 2000);
    },

    closeBackToSchoolAlertCard() {
      localStorage.setItem("backToShoolStatus", false);
      this.show_back_to_school_alert = false;
    },

    dialogueCompleted() {
      localStorage.setItem("now_show_back_to_school_banner", true);
      console.log();
      this.welcome_dialogue = !this.welcome_dialogue;
    },

    toggleInvitationModal() {
      this.invitation_modal = !this.invitation_modal;
    },

    confirmBoardedStatus() {
      // console.log("user boarded", this.getBoardedStatus);
      if (!localStorage.getItem("switchDone")) {
        // if (!this.getBoardedStatus) this.welcome_dialogue = true;
      }
    },

    updateBoardedStatus() {
      if (!this.getBoardedStatus) this.updateBoardingStatus();
    },

    getChildIDState() {
      this.posts = [];
      this.page = 1;
      this.page_end = 0;
      this.infinite_scroll_end = false;
      this.is_fetching = true;

      // console.log("recalling state id>>>>", this.getSelectedChildID);

      if (this.account_type === "parent") {
        if (this.getSelectedChildID) {
          // CHECK CHILD ID AGAINST ROUTE ID
          if (this.getSelectedChildID === this.$route.params.id)
            this.child_active_id = this.getSelectedChildID;
          else this.child_active_id = this.$route.params.id;

          this.fetchLatestPost();
        } else {
          this.getParentChildren()
            .then((response) => {
              if (response.code === 200) {
                let { data } = response;

                this.child_active_id = data[0].id;
                this.fetchLatestPost();
              } else {
                this.child_active_id = 0;
                this.fetchLatestPost();
              }
            })
            .catch((err) => console.log(err));
        }
      } else {
        this.child_active_id = this.getAuthUser.id;
        if (!this.getCurrentClass) {
          this.getStudentClassDetailsById()
            .then((response) => {
              this.setCurrentClass(response.data.class_id);
              this.fetchLatestPost();
            })
            .catch((err) => console.log(err));
        } else this.fetchLatestPost();
      }

      // CALL BOARDED STATUS METHOD
      this.confirmBoardedStatus();
    },

    fetchLatestPost() {
      // TIMESTAMP FOR NEW LOGIN
      let entry_timestamp = this.getAuthUser.entry_timestamp;
      let current_timestamp = Math.round(new Date().getTime() / 1000);
      let entry_range = current_timestamp - entry_timestamp;

      // FETCH FEEDS
      this.getFeeds({
        pageNumber: this.page,
        id: this.child_active_id,
      })
        .then((response) => {
          if (response.code === 200) {
            // console.log(response.data);
            this.is_fetching = false;
            let filtered_posts = response.data.filter((post) => {
              return (
                post.type !== "exam" ||
                (post.type === "homework" &&
                  `${post?.reference?.review_status}` === "1")
              );
            });

            if (entry_range < 32) this.posts = filtered_posts;
            else this.posts.push(...filtered_posts);

            this.page_end = response.pagination.pageCount;
          } else {
            this.posts = [];
            this.is_fetching = false;
          }
        })
        .catch((err) => console.log(err));
    },

    fetchMorePost(isVisible) {
      if (!isVisible) return; // CHECK SCROLLING VISIBILITY

      // CHECK IF PAGE IS EQAUL TO PAGE COUNT
      if (this.page === this.page_end) {
        this.infinite_scroll_end = true;
        return;
      }
      this.page += 1; //INCREASE PAGE NUMBER

      setTimeout(() => {
        this.fetchLatestPost();
      }, 300);
    },

    // EXTRACT DELETED POST
    extractDeletedPostFromList(id) {
      this.posts = this.posts.filter((post) => {
        return post.id !== id;
      });
    },
  },
};
</script>

<style lang="scss">
.class-feeds-section {
  .right-layout {
    @include breakpoint_max(lg) {
      padding-left: 30px;
      padding-right: 0px;
    }

    @include breakpoint_max(md) {
      margin-bottom: 80px;
      padding-left: 15px;
      padding-right: 15px;
    }
  }

  .post-component {
    min-width: 63%;
    max-width: 63%;
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 60px;

    @include breakpoint_max(lg) {
      min-width: 100%;
      max-width: 100%;
    }
  }

  .event-component {
    min-width: 36%;
    max-width: 36%;
    padding-right: 5px;

    @include breakpoint_max(lg) {
      min-width: 100%;
      max-width: 100%;
      padding-right: 15px;
      margin-bottom: 20px;
    }
  }

  .transition {
    transition: top 0.5s ease-in-out;
    animation: panel-slide-down 0.6s ease-in-out forwards;
  }
}
</style>
